import deliveryLoss from './deliveryLoss'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    deliveryLoss,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/delivery/index.js